import type {ISettings, ISettingsMapTilePreset} from '@/config/types';

export const settings: ISettings = {
  APP_VERSION: import.meta.env.VITE_APP_VERSION ?? __APP_VERSION__ ?? 'unknown',
  TEST: import.meta.env.TEST === 'true',
  SERVICES: {
    KEYCLOAK: {
      URL: import.meta.env.VITE_KEYCLOAK_URL ?? 'https://keycloak.sw.kbsynergya.ru',
      REALM:
        import.meta.env.VITE_KEYCLOAK_REALM ?? 'demo',
      CLIENT_ID:
        import.meta.env.VITE_KEYCLOAK_CLIENT_ID ??
        'tarvos_frontend',
      CLIENT_ID_ROLES:
        import.meta.env.VITE_KEYCLOAK_CLIENT_ID_ROLES ??
        'tarvos_backend',
    },
    FRONTEND: {
      STANDALONE: false,
      THEME: {},
    },
    BACKEND: {
      URL:
        import.meta.env.VITE_BACKEND_URL ?? 'https://demo-tarvos-backend.sw.kbsynergya.ru/api/v1',
    },
    NOTIFIER: {
      URL: import.meta.env.VITE_NOTIFIER_URL ?? 'https://demo-tetis-frontend.sw.kbsynergya.ru',
      BACKEND_URL:
        import.meta.env.VITE_NOTIFIER_BACKEND_URL ??
        'https://demo-tetis-backend.sw.kbsynergya.ru/api/v1',
    },
  },
  PARENT: (() => {
    const POLLING_PLACEHOLDER = '1000';
    const pollingRaw =
      import.meta.env.VITE_POLLING_INTERVAL_MS || POLLING_PLACEHOLDER;
    const pollingParsed = parseInt(pollingRaw, 10);

    return {
      POLLING__INTERVAL_MS:
        Number.isFinite(pollingParsed) && pollingParsed > 0 ? pollingParsed : 0,
      MAP__TILE_PRESETS: (() => {
        const fallback: ISettingsMapTilePreset = {
          name: 'OpenStreetMap',
          tiles: [
            {
              url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
              minZoom: 3,
              maxZoom: 19,
            },
          ],
        };
        const raw =
          import.meta.env.VITE_MAP_TILE_PRESETS ??
          '';
        if (raw.endsWith('PLACEHOLDER')) return [fallback];
        try {
          const parsed = JSON.parse(raw);
          if (Array.isArray(parsed) && parsed.length) return parsed;
          return [fallback];
        } catch {
          return [fallback];
        }
      })(),
    };
  })(),
};

// placeholder to external theme
settings.SERVICES.FRONTEND.THEME = {};

if (Object.keys(settings.SERVICES.FRONTEND.THEME).length === 0) {
  settings.SERVICES.FRONTEND.THEME = {
    // colorPrimary: '#9d0000',
    colorPrimary: '#a30a0a',
    colorPrimaryBg: '#f6efef',

    colorError: '#ff0100',
  };
}

if (settings.TEST) {
  settings.SERVICES.BACKEND.URL = 'https://mock.com';
}

export default settings;
